// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import GatewayOutlinedSvg from "@fishx/icons-svg/es/asn/GatewayOutlined";
import FishxIcon from '../components/FishxIcon';

var GatewayOutlined = function GatewayOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: GatewayOutlinedSvg
  }));
};

GatewayOutlined.displayName = 'GatewayOutlined';
export default React.forwardRef(GatewayOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/GatewayOutlined.js
// module id = 2857
// module chunks = 0